export const KFormSearchDefaultProps = {
  dataTitleType: 'text',      // card头显示样式： icon     text
  dataBtnType: 'kayakTheme',      // btn样式： kayakTheme主题样式
  dataTitleShow: false, //card头是否显示 true false
}

export const KFormSearchCustomizeDefaultProps = {
  dataTitleType: 'text',      // card头显示样式： icon     text
  dataBtnType: 'kayakTheme',      // btn样式： kayakTheme主题样式
  dataTitleShow: false, //card头是否显示 true false
}

export const KGridDefaultProps = {
  dataTitleType: 'text',      // card头显示样式： icon     text
  dataTitleStyle: 'new', // card头样式风格： new     old
}

export const KBtnDefaultProps = {
  dataShowIcon: false,  //是否显示图标 true    false
}

export const KPagerDefaultProps = {
  dataPagerType: 'kayakTheme',  //分页的样式:  kayakTheme主题样式
}



// WEBPACK FOOTER //
// ./src/components/k-element-default-config/defaultConfig.js